import { Component, Input, OnInit } from '@angular/core';
import { AppConfig } from 'src/app/config-service/app.config';
import { cardDetailResModel } from 'src/app/home/models/cardBalanceResponse.model';

@Component({
  selector: 'app-usage-information',
  templateUrl: './usage-information.component.html',
  styleUrls: ['./usage-information.component.scss', '../../../../home/home.component.scss']
})
export class UsageInformationComponent implements OnInit {
  @Input() card!: cardDetailResModel;
  @Input() favorite!:string;

  apiSettings = AppConfig.settings;

  constructor() { }

  ngOnInit(): void {
  }

}
